import { useContext } from 'react'

import AppContext from '@/common/context/app.context'
import useRegions from '@/common/hooks/useRegions/useRegions'
import useReturnPortalFeatures from '@/common/hooks/useReturnPortalFeatures/useReturnPortalFeatures'
import useFilters from '@/metrics/hooks/useFilters/useFilters'
import { subReasonsFilters } from '@/metrics/pages/ReasonMetricDetailPage/constants'
import { getReasonSummaryOrdering, getShowExchanges } from '@/metrics/pages/ReasonMetricDetailPage/helpers'

import useReasonSummary from '../useReasonSummary/useReasonSummary'

const useReasonDetailSetup = ({ reasonKey, isUnifiedDashboard }) => {
  const { info } = useContext(AppContext)
  const { regions } = useRegions()

  const { commonFilters, setCommonFilters, getUrlSearchParams, productsFilters, setProductsFilters, reasonsFilters } =
    useFilters()

  const returnPortalId = isUnifiedDashboard ? null : info?.selectedReturnPortal?.id

  const { returnPortalFeatures } = useReturnPortalFeatures({ returnPortalId: info?.selectedReturnPortal?.id })
  const salesOrdersDataActivated = returnPortalFeatures?.sales_orders_data_activated

  const showExchanges = getShowExchanges(returnPortalFeatures, isUnifiedDashboard)
  const subReasonsOrdering = getReasonSummaryOrdering({
    reasonsFilters: subReasonsFilters,
    configurationPreferences: returnPortalFeatures,
    isUnifiedDashboard,
  })

  const { reasonSummary, loadingReasonSummary, reasonSummaryError } = useReasonSummary({
    reasonKey,
    filters: commonFilters,
    ordering: getReasonSummaryOrdering({
      reasonsFilters,
      configurationPreferences: returnPortalFeatures,
      isUnifiedDashboard,
    }),
    returnPortalId,
  })

  return {
    info,
    regions,
    commonFilters,
    setCommonFilters,
    getUrlSearchParams,
    productsFilters,
    setProductsFilters,
    returnPortalId,
    salesOrdersDataActivated,
    showExchanges,
    subReasonsOrdering,
    reasonSummary,
    loadingReasonSummary,
    reasonSummaryError,
  }
}

export default useReasonDetailSetup
